import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  allitems: [],
  loading: false,
  error: null,
};

const itemSlice = createSlice({
  name: "allitems",
  initialState,
  reducers: {
    setItems: (state, action) => {
      state.allitems = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setItems, setLoading, setError } = itemSlice.actions;

export const fetchItems = () => async (dispatch) => {
  dispatch(setLoading());
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/items/allitems`);
    dispatch(setItems(response.data));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export default itemSlice.reducer;
